import React, { useRef, useState } from 'react'
import defaultImg from '../../assets/svg/Vector.png'
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css"; 
import { Form } from "react-bootstrap";
import '../../components/Rewards/Rewards.css'

  export default function AddNewReward() {

  const [dateRange, setDateRange] = useState([]);

  const [discountReward, setDiscountReward] = useState(false);
  const [productReward, setProductReward] = useState(false);
  const [serviceReward, setServiceReward] = useState(false);
  
  const handleDiscountReward = () => {
    console.log("Discount selected");
    setDiscountReward(true);
    setProductReward(false);
    setServiceReward(false);
  };

  const handleProductReward = () => {
    console.log("Product selected");
    setDiscountReward(false);
    setProductReward(true);
    setServiceReward(false);
  };

  const handleServiceReward = () => {
    console.log("Service selected");
    setDiscountReward(false);
    setProductReward(false);
    setServiceReward(true);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (value === "discount") {
      handleDiscountReward();
    } else if (value === "product") {
      handleProductReward();
    } else if (value === "service") {
      handleServiceReward();
    }
  };
  
  const fileInputRef = useRef(null);
  const [imagePreview, setImagePreview] = useState(null);

  const handleClick = () => {
        fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.size <= 2 * 1024 * 1024) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setImagePreview(reader.result);
          };
          reader.readAsDataURL(file);
        } else {
          alert('File is too large. Max size is 2MB.');
        }
  };
    
  return (
    <>
      <div className="m-4">
        {/* reward header */}
        <div className="reward-header d-flex justify-content-between align-items-center">
          <p className=" fs-5 fw-bold my-0">Add New Reward</p>
          <div className=" me-1">
            <button
              className="btn border border-1 px-3 py-2 mx-4"
              //   onClick={toggleCustomAudience}
            >
              <i className="fa-solid fa-eye text-muted fa-sm me-2"></i>
              Preview
            </button>
            <button
              className=" btn btn-danger opacity-75 py-2"
              //   onClick={toggleCustomAudience}
            >
              Inactive Reward
            </button>
          </div>
        </div>
        {/* add new reward */}
        <div className="border border-1 rounded-2 my-4">
          <div className="row p-3">
            <p className=" mt-0 mb-1">Reward Image</p>
            <div className="reward-image-container my-2 p-3">
              <div className="d-flex justify-content-start align-items-center w-50">
                <div
                  className="reward-image rounded-3 bg-light p-4 my-1 d-flex justify-content-center align-items-center cursor"
                  style={{ width: imagePreview ? '50%' : '25%'}}
                  onClick={handleClick}
                >
                  <img
                    src={imagePreview || defaultImg}
                    className="w-100"
                    alt="Upload preview"
                  />
                </div>
                <p className="mx-3 my-0 fw-semibold">
                  Upload an image. Max size 2MB
                </p>
              </div>

              <button className="btn border border-1" onClick={handleClick}>
                Browse
              </button>

              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                ref={fileInputRef}
                onChange={handleFileChange}
              />
            </div>
            <div className="reward-name my-2">
              <label for="Rname" className="form-label">
                Reward Name
              </label>
              <input
                className="form-control"
                id="Rname"
                placeholder="Enter Reward Name"
              />
            </div>
            <div className="reward-description my-2">
              <label for="description" className="form-label">
                Description
              </label>
              <textarea
                className="form-control"
                id="description"
                placeholder="Enter Reward Description"
                rows={5}
              />
            </div>
            <div className="reward-section col-6 ">
              <div className="my-2 reward-type">
                <label for="Type" className="form-label">
                  Reward Type
                </label>
                <select
                  className="form-select"
                  aria-label="Select Type"
                  onChange={handleChange}
                >
                  <option value="">Select Type</option>
                  <option value="discount">Discount</option>
                  <option value="product">Product</option>
                  <option value="service">Service</option>
                </select>
              </div>
              {discountReward ? (
                <>
                  <div className="my-2 min-order-value">
                    <label for="min-value" className="form-label">
                      Min Value of the order
                    </label>
                    <input
                      type="number"
                      className=" form-control"
                      placeholder="Select Number"
                      id="min-value"
                    />
                  </div>
                </>
              ) : productReward ? (
                <div className="my-2 product-item">
                  <label for="product-item" className="form-label">
                    Product Item
                  </label>
                  <select
                    className="form-select"
                    aria-label="Select Type"
                    id="product-item"
                    // onChange={handleChange}
                  >
                    <option value="">Select Product Item</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              ) : serviceReward ? (
                <div className="my-2 service-item">
                  <label for="service-item" className="form-label">
                    Service
                  </label>
                  <select
                    className="form-select"
                    aria-label="Select Type"
                    id="service-item"
                    // onChange={handleChange}
                  >
                    <option value="">Select Service</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              ) : (
                ""
              )}
              <div className="my-2 reward-audience">
                <label for="Audience" className="form-label">
                  Audience
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                >
                  <option selected>Select Audience</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </select>
              </div>
            </div>
            <div className="reward-section col-6">
              {discountReward ? (
                <>
                  <div className="my-2 discount-type">
                    <label for="discount-Type" className="form-label">
                      Discount Type
                    </label>
                    <select
                      className="form-select"
                      aria-label="Select Type"
                      // onChange={handleChange}
                    >
                      <option value="">Select Discount Type</option>
                      <option value="1">Fixed Value</option>
                      <option value="2">Percentage</option>
                    </select>
                  </div>
                  <div className="my-2 order-value">
                    <label for="value" className="form-label">
                      Max Value of the order
                    </label>
                    <input
                      type="number"
                      className=" form-control"
                      placeholder="Select Number"
                      id="value"
                    />
                  </div>
                </>
              ) : productReward ? (
                <div className="my-2 product-price">
                  <label for="product-price" className="form-label">
                    Product Price
                  </label>
                  <input
                    type="number"
                    className=" form-control"
                    placeholder="Enter Product Price Or Range"
                    id="product-price"
                  />
                </div>
              ) : serviceReward ? (
                <div className="my-2 service-category">
                  <label for="service-category" className="form-label">
                    Service Category
                  </label>
                  <select
                    className="form-select"
                    aria-label="Select Type"
                    id="service-category"
                    // onChange={handleChange}
                  >
                    <option value="">Select Service Category</option>
                    <option value="1">Oil</option>
                    <option value="2">Tire</option>
                    <option value="2">Battery</option>
                  </select>
                </div>
              ) : (
                ""
              )}
              <div className="my-2 reward-Quantity">
                <label for="Quantity" className="form-label">
                  Available Quantity
                </label>
                <input
                  type="number"
                  className=" form-control"
                  placeholder="Select Number"
                  id="Quantity"
                />
              </div>
              <div className="my-2 reward-date">
                <Form.Group>
                  <Form.Label>Validity Dates</Form.Label>
                  <Flatpickr
                    className="form-control"
                    placeholder="Select Dates"
                    options={{
                      mode: "range",
                      dateFormat: "Y-m-d",
                      showMonths: 2,
                    }}
                    value={dateRange}
                    onChange={(selectedDates) => {
                      setDateRange(selectedDates);
                    }}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
          <div className="reward-footer w-25 mx-auto d-flex justify-content-center align-items-center my-3">
            <button className=" btn border border-1 px-5 me-3">Cancel</button>
            <button className=" btn btn-dark px-5 me-3">Save</button>
          </div>
        </div>
      </div>
    </>
  );
}
